import { Box, BoxProps, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { useCallback } from 'react'
import { FileSelector } from '../../components/FileSelector'
import { ListNew } from '../../components/ListNew'

import React from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'

const FileUpload = () => {
  const navigation = useNavigation()

  const { fetchFiles, accessConfig, download, upload } = useStores((store) => ({
    fetchFiles: store.fileUpload.fetchAllFiles,
    length: store.fileUpload.files.length,
    download: store.fileUpload.download,
    upload: store.fileUpload.fileUpload,
    accessConfig: store.user.getAccessConfig(['routing', 'package_file_upload']),
  }))

  const [lazyFetchFiles, { state, data }] = useLazyApiData(fetchFiles)
  const [lazyDownloadFile] = useLazyApiData(download)
  const [lazyUploadFile, lazyUploadHandler] = useLazyApiData(upload)
  const searchFormRef = React.useRef(null)
  useFocusEffect(
    useCallback(() => {
      lazyFetchFiles(searchFormRef?.current?.getValues(), { page: 1, size: 10 })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation]),
  )

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { fileName: 'File Name' },
    { fromDate: 'From' },
    { toDate: 'To' },
    { duration: 'Time in Run(min)' },
    { status: 'Active' },
    { link: 'Link' },
    { uploadedBy: 'Uploaded By' },
  ]

  const handleDownload = ({ item }: any) => {
    console.log('item=', item)
    lazyDownloadFile(item.link, item.fileName, item.originalFileName)
  }

  const fetchDataFromServer = useCallback(
    (data, paginationInfo) => {
      lazyFetchFiles(data, paginationInfo)
    },
    [lazyFetchFiles],
  )

  const renderList = () => {
    return (
      <ListNew
        searchFormRef={searchFormRef}
        searchData={UPLOAD_HISTORY_SEARCH_FILTERS as any}
        updatedPaginationInfo={{
          ...(data?.pageNo !== undefined && { page: data?.pageNo }),
          ...(data?.totalElements !== undefined && {
            total: data?.totalElements,
          }),
        }}
        isSearchButtonLoading={state === ('pending' as any)}
        apiHandler={{ state, data }}
        fetchDataFromServer={fetchDataFromServer}
        keyExtractor={keyExtractor}
        headTitle={headTitles}
        sizeConfig={[2, 1.5, 1.5, 1.2, 1.2, 0.9, 1]}
        data={data?.content}
        listTitle={'Upload History'}
        onRowItemClick={handleDownload}
        dbCollumnMapper={{
          fileName: 'SAV_FILE_NAME',
          fromDate: 'CREATED_DATE',
          toDate: 'UPLOADED_TO',
          status: 'IS_ACTIVE',
          uploadedBy: 'CREATED_BY',
        }}
      />
    )
  }

  return (
    <Box f={1}>
      <Text title={'Package File Upload'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'add') && (
        <>
          <Box w={'50%'}>
            <Box {...styles.title} bg={'#f8f9fc' as ColorOptions}>
              <Text fontFamily="jiotype-bold" color={'#214796' as ColorOptions} fontSize={16} title={'File Upload'} />
            </Box>
            <Box {...styles.uploadContainer}>
              <Text
                title={'Package File Upload'}
                color={'#858796' as ColorOptions}
                fontSize={16}
                fontFamily={'jiotype-medium'}
              />
              <FileSelector onPress={lazyUploadFile} isLoading={lazyUploadHandler.state === 'pending'} />
            </Box>
          </Box>
          <Spacer direction={'vertical'} size={16} />
        </>
      )}
      {isAccessible(accessConfig, 'fetch') && renderList()}
    </Box>
  )
}

export default FileUpload

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
  } as BoxProps,
  innerContainer: {
    backgroundColor: 'WHITE',
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    padding: 16,
  } as BoxProps,
  listContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
  } as BoxProps,
  title: {
    ...shadow,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  uploadContainer: {
    ...shadow,
    backgroundColor: 'WHITE',
    padding: 16,
    underlayColor: 'WHITE',
    borderColor: '#e3e6f0' as ColorOptions,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    minHeight: 105,
    pt: 20,
  } as BoxProps,
}

export const UPLOAD_HISTORY_SEARCH_FILTERS = [
  [
    { key: 'savedFileName', type: 'string', placeHolder: 'File Name' },
    {
      key: 'fromDate',
      type: 'date',
      placeHolder: 'Select From Date',
    },
    {
      key: 'toDate',
      type: 'date',
      placeHolder: 'Select To Date',
    },
  ],
  [
    {
      key: 'isActive',
      type: 'dropdown',
      placeHolder: 'Is Active',
      data: [
        { id: 1, value: 'ACTIVATED' },
        { id: 2, value: 'DEACTIVATED' },
      ],
    },
    { key: 'createdBy', type: 'string', placeHolder: 'Uploaded By' },
  ],
]
